<template>
  <v-card>
    <v-card-title class="subheading font-weight-bold">Visita</v-card-title>

    <v-divider></v-divider>

    <v-list dense>
      <v-list-item>
        <v-list-item-content>Data da Visita</v-list-item-content>
        <v-list-item-content
          class="align-end pl-6"
          :title="details.data_da_visita"
        >
          <span class="text-highlight" :style="{ color }">
            {{ this.details.data_da_visita.slice(8, -14) }}/{{
              this.details.data_da_visita.slice(5, -17)
            }}/{{ this.details.data_da_visita.slice(0, -20) }}
          </span>
        </v-list-item-content>
      </v-list-item>

      <v-divider />

      <v-list-item>
        <v-list-item-content>Marca</v-list-item-content>
        <v-list-item-content class="align-end pl-6" :title="details.marca">
          <span class="text-highlight" :style="{ color }">{{
            details.marca
          }}</span>
        </v-list-item-content>
      </v-list-item>

      <v-divider />

      <v-list-item>
        <v-list-item-content>Loja</v-list-item-content>
        <v-list-item-content class="align-end pl-6" :title="details.loja">
          <span class="text-highlight" :style="{ color }">{{
            details.loja
          }}</span>
        </v-list-item-content>
      </v-list-item>

      <v-divider />

      <v-list-item>
        <v-list-item-content>Canal de Atendimento</v-list-item-content>
        <v-list-item-content
          class="align-end pl-6"
          :title="details.canal_de_atendimento"
        >
          <span class="text-highlight" :style="{ color }">{{
            details.canal_de_atendimento
          }}</span>
        </v-list-item-content>
      </v-list-item>

      <v-divider />

      <v-list-item>
        <v-list-item-content>Entrega/Retirada</v-list-item-content>
        <v-list-item-content
          class="align-end pl-6"
          :title="details.entrega_retirada"
        >
          <span class="text-highlight" :style="{ color }">{{
            details.entrega_retirada
          }}</span>
        </v-list-item-content>
      </v-list-item>

      <v-divider />

      <v-list-item>
        <v-list-item-content>Categoria do Prato</v-list-item-content>
        <v-list-item-content
          class="align-end pl-6"
          :title="details.CATEGORIA_PRATO"
        >
          <span class="text-highlight" :style="{ color }">{{
            details.CATEGORIA_PRATO
          }}</span>
        </v-list-item-content>
      </v-list-item>

      <v-divider />

      <v-list-item>
        <v-list-item-content>Prato</v-list-item-content>
        <v-list-item-content class="align-end pl-6" :title="details.PRATO">
          <span class="text-highlight" :style="{ color }">{{
            details.PRATO
          }}</span>
        </v-list-item-content>
      </v-list-item>

      <!-- <v-list-item>
        <v-list-item-content>Escolha da Loja</v-list-item-content>
        <v-list-item-content
          class="align-end pl-6"
          :title="details.escolha_da_loja"
        >
          <span class="text-highlight" :style="{ color }">{{
            details.escolha_da_loja
          }}</span>
        </v-list-item-content>
      </v-list-item> -->

      <!-- <v-list-item>
        <v-list-item-content>Pedido Incorreto</v-list-item-content>
        <v-list-item-content
          class="align-end pl-6"
          :title="details.pedido_incorreto"
        >
          <span class="text-highlight" :style="{ color }">{{
            details.pedido_incorreto
          }}</span>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>Motivo do Pedido Incorreto</v-list-item-content>
        <v-list-item-content
          class="align-end pl-6"
          :title="details.motivo_do_pedido_incorreto"
        >
          <span class="text-highlight" :style="{ color }">{{
            details.motivo_do_pedido_incorreto
          }}</span>
        </v-list-item-content>
      </v-list-item> -->

      <!-- <v-divider /> -->

      <!-- <v-list-item>
        <v-list-item-content>Nome da loja</v-list-item-content>
        <v-list-item-content class="align-end pl-6" :title="details.nome_loja">
          <span class="text-highlight" :style="{ color }">{{
            details.nome_loja
          }}</span>
        </v-list-item-content>
      </v-list-item>

      <v-divider />

      <v-list-item>
        <v-list-item-content>Gerência</v-list-item-content>
        <v-list-item-content
          class="align-end pl-6"
          :title="details.regional_loja"
        >
          <span class="text-highlight" :style="{ color }">{{
            details.regional_loja
          }}</span>
        </v-list-item-content>
      </v-list-item>

      <v-divider />

      <v-list-item>
        <v-list-item-content>Divisão</v-list-item-content>
        <v-list-item-content class="align-end pl-6" :title="details.divisao">
          <span class="text-highlight" :style="{ color }">{{
            details.divisao
          }}</span>
        </v-list-item-content>
      </v-list-item> -->

      <!-- <v-divider />

      <v-list-item>
        <v-list-item-content>Journey</v-list-item-content>
        <v-list-item-content class="align-end pl-6" :title="details.journey">
          <span class="text-highlight" :style="{ color }">{{
            details.journey
          }}</span>
        </v-list-item-content>
      </v-list-item>

      <v-divider />

      <v-list-item>
        <v-list-item-content>Departamento</v-list-item-content>
        <v-list-item-content
          class="align-end pl-6"
          :title="details.departamento"
        >
          <span class="text-highlight" :style="{ color }">{{
            details.departamento
          }}</span>
        </v-list-item-content>
      </v-list-item> -->
    </v-list>
  </v-card>
</template>

<script>
export default {
  name: "Purchase",

  props: {
    details: {
      type: Object,
      required: true,
    },
  },

  computed: {
    color() {
      return this.$vuetify.theme.dark
        ? this.$vuetify.theme.themes.dark.primary
        : this.$vuetify.theme.themes.light.primary;
    },
  },
  methods: {
    formatDates(date) {
      let dateTurn = date.split("T")[0];
      let split = dateTurn.split("-");
      date = split;
      date = new Date(`${split[1]}/${split[2]}/${split[0]}`);
      return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
    },
  },

  filters: {
    date: (str) => new Date(str).toLocaleString(),
  },
};
</script>

<style scoped>
.v-list {
  max-height: 75vh;
  overflow: auto;
}

.text-highlight {
  display: contents;
}
</style>